import React from "react";

import * as R from "ramda";

import { Dropdown, Flex, Text } from "src/components";

import ValidationIcon from "./ValidationIcon";

import { getLanguageSuffix } from "src/utils";

const translateOptions = (options, language) => {
  const languageSuffix = getLanguageSuffix(language);

  return R.map(option =>
    R.assoc("label", option[`label${languageSuffix}`] || option.label, option)
  )(options);
};

export default ({ ...props }) => (
  <Flex
    mt={0}
    mb={2}
    flex="1 0 auto"
    flexDirection={
      props.wrap ? "column" : ["column", "column", "column", "row"]
    }
    align={props.wrap ? undefined : ["stretch", "stretch", "stretch", "center"]}
    {...props.displayProps}
  >
    {props.suppressLabel ? null : (
      <Flex
        mr={3}
        ml={props.wrap ? 2 : [2, 3, 3, 0]}
        mb={props.wrap ? 1 : [1, 1, 1, 0]}
      >
        <Text fontWeight="semibold" mr={2}>
          {props.label}
        </Text>

        <ValidationIcon {...props} />
      </Flex>
    )}
    {props.renderHelpText({
      containerProps: {
        mt: 1,
        mb: 1,
      },
    })}
    <Dropdown
      value={props.value}
      onChange={value => {
        props.onTouch();
        props.setValue(value);
      }}
      items={translateOptions(props.options, props.language)}
      placeholder={props.placeholder}
      renderValue={props.renderValue}
      id={props.id}
    />
  </Flex>
);



// WEBPACK FOOTER //
// ./src/components/Form/DropdownInput.js